export const FLIGHT_REVALIDATION_ACTION = Object.freeze({
  CONTINUE: "continue",
  CONFIRM_PRICE_RISE: "confirm-price-rise",
  RESEARCH: "research",
});

export function getFlightRevalidationAction(submitOrderResponse) {
  const status = submitOrderResponse?.revalidateResult?.status;

  if (status === "Sold out") {
    return FLIGHT_REVALIDATION_ACTION.RESEARCH;
  }

  if (status === "Price rise") {
    return FLIGHT_REVALIDATION_ACTION.CONFIRM_PRICE_RISE;
  }

  return FLIGHT_REVALIDATION_ACTION.CONTINUE;
}
